export default __webpack_public_path__ + "static/media/win.d8e17c8f.mp4";